export const defaultInfos = [];
export const defaultCautions = [
  {
    contents:
      '챌린지 참여 시, 정확하고 명확한 인증을 위해 식별이 잘 되는 사진을 제출해 주세요. 챌린지별 인증방법과 맞지 않는 사진을 업로드 시 챌린지 도전이 실패 처리될 수 있어요.',
  },
  {
    contents:
      '챌린지는 에코야 얼스의 운영상황에 따라 별도의 예고 없이 마감 또는 변경될 수 있어요.',
  },
  {
    contents:
      '민감한 정보가 담긴 사진이나 타인의 개인정보를 포함한 사진을 제출 하는 경우 사진이 삭제처리 되며, 지급된 얼스 크레딧이 회수처리 될 수 있어요.',
  },
  {
    contents:
      '챌린지 별로 지급되는 얼스 크레딧은 상이할 수 있으며, 챌린지 인증 후 즉시 지급돼요.',
  },
  {
    contents:
      '보상으로 지급되는 얼스 크레딧은 에코야 얼스 앱 내 응모하기, 기부하기 등에서 사용가능해요. 유효기간은 지급일로부터 1년이며, 유효기간 이후에는 사용 및 재발급이 불가능해요.',
  },
  {
    contents:
      '사진 업로드 혹은 인증 과정에서 기술적 문제가 발생할 경우, 에코야 얼스 앱 > 전체 > 1:1문의 페이지 혹은 에코야 얼스 카카오톡 채널에 문의해 주세요.',
  },
];
